module.exports = __webpack_public_path__ + "media/images/ac_templates/201/purht-886576baef3ba927b0919f4a2e246037.jpg";